import script from "./ForkDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ForkDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./ForkDashboardModal.vue?vue&type=style&index=0&id=3cf88e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf88e15"]])

export default __exports__